export const formatPrice = (
  price: number,
  {
    currencyCode = 'USD',
    displayTrailingZeros = false,
  }: { currencyCode?: string; displayTrailingZeros?: boolean } = {},
) => {
  if (price === 0) {
    return '$0.00'
  }
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: displayTrailingZeros ? 2 : 0,
    //@ts-ignore
    trailingZeroDisplay: displayTrailingZeros ? 'auto' : 'stripIfInteger',
  })

  return formatter.format(price)
}

export const clampValue = (
  value: number,
  { min, max }: { min?: number; max?: number },
) => {
  if (min != null && value < min) {
    return min
  }
  if (max != null && value > max) {
    return max
  }

  return value
}
